import { Autocomplete, TextField } from "@mui/material";
import axios, { AxiosResponse } from "axios";
import React from "react";
import { AppContext, User } from "../../../../../context/appContext";
import { endpoints } from "../../../../../endpoints/endpoints";
import SelectableUserProps from "../../interface/selectableUserProps";
import UserSearchProps from "../../interface/userSearchProps";

const MINIMUM_SEARCH_LENGTH = 2;

const RenderUserSearch = ({
  userSearch,
  setUserSearch,
}: {
  userSearch: UserSearchProps;
  setUserSearch: React.Dispatch<React.SetStateAction<UserSearchProps>>;
}): React.JSX.Element => {
  const {
    user,
    checkSession,
  }: {
    user: User;
    checkSession: (response: AxiosResponse) => void;
  } = React.useContext(AppContext);

  const startSearch = (searchString: string): void => {
    setUserSearch((currentSearch) => ({ ...currentSearch, loading: true }));

    axios
      .post(endpoints.admin.searchParticipant, {
        sessionId: user.sessionId,
        searchString: searchString,
      })
      .then((response) => {
        checkSession(response);

        setUserSearch((currentSearch) => ({
          ...currentSearch,
          loading: false,
          searchResults:
            response.data.meta.status === "success" ? response.data.data : [],
        }));
      })
      .catch((error) => {
        console.error(error);
        setUserSearch((currentSearch) => ({
          ...currentSearch,
          loading: false,
          searchResults: [],
        }));
      });
  };

  const buildLabel = (option: SelectableUserProps): string =>
    `${option.firstName} ${option.lastName} (${option.email})`;

  return (
    <Autocomplete
      fullWidth
      loading={userSearch.loading}
      loadingText="Suche..."
      disablePortal
      noOptionsText="Bitte mindestens 2 Zeichen eingeben."
      id="searchUserForAdminRights"
      options={userSearch.searchResults}
      getOptionLabel={buildLabel}
      value={userSearch.selectedUser}
      isOptionEqualToValue={(option, value) =>
        option.participantId === value.participantId
      }
      onInputChange={(_event, value) => {
        setUserSearch((currentSearch) => ({
          ...currentSearch,
          searchString: value,
        }));

        if (userSearch.loading) return;
        if (value.length < MINIMUM_SEARCH_LENGTH) return;

        startSearch(value);
      }}
      onChange={(_event, option: SelectableUserProps | null) => {
        setUserSearch((currentSearch) => ({
          ...currentSearch,
          selectedUser: option,
        }));
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          color="success"
          label="User:in"
          error={
            userSearch.searchString.length < MINIMUM_SEARCH_LENGTH &&
            !userSearch.selectedUser
          }
          helperText={
            userSearch.searchString.length < MINIMUM_SEARCH_LENGTH &&
            !userSearch.selectedUser
              ? "Bitte mindestens 2 Zeichen eingeben"
              : ""
          }
        />
      )}
    />
  );
};

export default RenderUserSearch;
